// extracted by mini-css-extract-plugin
export default {"intro":"ContactPage_intro__BsPaa","maincontainer":"ContactPage_maincontainer__2DCPo"};